// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"862":"0101d983","988":"94d967e4"}[chunkId] + ".chunk.css";
};